import type { TooltipProps as MuiTooltipProps } from "@mui/material/Tooltip";
import MuiTooltip from "@mui/material/Tooltip";
import { forwardRef } from "react";

import Styles from "./Tooltip.module.scss";

interface TooltipProps extends Pick<MuiTooltipProps, "arrow" | "placement" | "title"> {
    children: React.ReactNode;
    delay?: number;
}

export const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(
    ({ arrow, children, delay = 0, placement, title }, ref) => (
        <MuiTooltip arrow={arrow} enterTouchDelay={delay} placement={placement} title={title}>
            <div className={Styles.TooltipComponent} ref={ref}>
                {children}
            </div>
        </MuiTooltip>
    ),
);

Tooltip.displayName = "Tooltip";
